import { Injectable, inject } from '@angular/core'
import { Action, Store, select } from '@ngrx/store'

import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import * as InfoboothsSelectors from './infobooths.selectors'

@Injectable({
  providedIn: 'root',
})
export class InfoboothsFacade implements GbBaseFacade {
  private readonly store = inject(Store)

  loaded$ = this.store.pipe(select(InfoboothsSelectors.selectInfoboothsLoaded))
  allInfobooths$ = this.store.pipe(select(InfoboothsSelectors.selectAllInfobooths))
  selectedInfobooths$ = this.store.pipe(select(InfoboothsSelectors.selectEntity))
  editCreateLoaded$ = this.store.pipe(select(InfoboothsSelectors.selectEditCreateLoaded))

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
